// extracted by mini-css-extract-plugin
export default {"productGrid":"T0-z","centerLink":"U0-z","productSection":"V0-z","item":"W0-z","ctaButton":"X0-z"};